import { EdgelessMinimapCanvas } from './minimap-canvas';

export function effects() {
  if (!customElements.get('edgeless-minimap-canvas'))
    customElements.define('edgeless-minimap-canvas', EdgelessMinimapCanvas);
}
